export default "__VITE_ASSET__eabf1402__"